import { createReducer } from 'reduxsauce'
import { configDuckList } from '~/store/config'

export const { 
  Connector, 
  Route, 
  Types, 
  Creators 
} = configDuckList("@Racing", { Connector: "News_1", Route: "racings" });

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: false,
  result: []
}

const getNoticesRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
  success: false
})

const getNoticesSuccess = (state = INITIAL_STATE, { data : {  result } }) => ({
  ...state,
  result,
  loading: false,
  success: true,
})

export default createReducer(INITIAL_STATE, {
  [Types.GET_REQUEST]: getNoticesRequest,
  [Types.GET_SUCCESS]: getNoticesSuccess,
})